//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { fetch } from '@/page/index'
import dayjs from 'dayjs'
import { resolveApprovalRouteName, buildApprovalDetailQuery } from './utils/approvalRouteMap'

export default {
  data () {
    return {
      activeNames: [],
      showStart: false,
      startDate: null,
      minDate: new Date(2020, 0, 1),
      params: {
        title: '',
        applyStartDate: '',
      },

      pendingList: [],

      pageIndex: 1,
      pageRows: 20,
      refreshing: false,
      finished: false,
      loading: false,
    }
  },
  computed: {
    ...mapState({
      languageCode: (state) => state.user.languageCode,
    }),
  },
  methods: {
    getDisplayTitle (item) {
      if (!item || item.bpmTitle == null || item.bpmTitle === '') return '-'
      return item.bpmTitle
    },
    getDisplayUserName (item) {
      if (!item || item.bpmUserFullName == null || item.bpmUserFullName === '') return '-'
      return item.bpmUserFullName
    },
    getDisplayTime (item) {
      if (!item || item.bpmStartTime == null || item.bpmStartTime === '') return '-'
      return item.bpmStartTime
    },
    onRefresh () {
      this.refreshing = true
      this.loading = false
      this.finished = false
      this.pageIndex = 1
      this.params = {
        title: '',
        applyStartDate: '',
      }
      this.pendingList = []
      this.requestQuotes()
    },
    onSearch () {
      this.refreshing = true
      this.loading = false
      this.finished = false
      this.pageIndex = 1
      this.pendingList = []
      this.requestQuotes()
    },
    /** 是否已无下一页，避免 van-list 在空数据时反复 @load */
    isListEnd (res, rows) {
      if (!rows || !rows.length) return true
      if (rows.length < this.pageRows) return true
      const page = res && res.page
      if (!page) return false
      if (page.pagesCount != null && page.curIndex >= page.pagesCount) return true
      if (page.nextIndex != null && page.curIndex != null && page.nextIndex === page.curIndex) {
        return true
      }
      return false
    },
    resetListLoadingState () {
      this.refreshing = false
      this.loading = false
    },
    requestQuotes () {
      if (this.finished) {
        this.loading = false
        return
      }
      const payload = {
        lan: this.languageCode || 'CN',
        pageIndex: this.pageIndex,
        pageRows: this.pageRows,
        bpmResult: 'APPROVAL',
      }
      const titleTrim = (this.params.title && String(this.params.title).trim()) || ''
      if (titleTrim) {
        payload.title = titleTrim
      }
      const dateTrim = (this.params.applyStartDate && String(this.params.applyStartDate).trim()) || ''
      if (dateTrim) {
        payload.applyStartDate = dateTrim
      }
      fetch
        .bpmRestful_findTodoTasks(payload)
        .then((res) => {
          this.resetListLoadingState()
          if (res.status !== 'S') {
            this.finished = true
            return
          }
          const rows = Array.isArray(res.data) ? res.data : []
          const page = res.page || {}
          const curPageIndex = page.curIndex != null ? page.curIndex : this.pageIndex
          const curIndex = (curPageIndex - 1) * this.pageRows
          const lastLength = this.pendingList.length - curIndex
          if (lastLength > 0) {
            this.pendingList.splice(curIndex, lastLength)
          }
          this.pendingList = this.pendingList.concat(rows)

          if (this.isListEnd(res, rows)) {
            this.finished = true
            return
          }
          this.pageIndex = page.nextIndex != null ? page.nextIndex : this.pageIndex + 1
        })
        .catch(() => {
          this.resetListLoadingState()
          this.finished = true
        })
    },
    goToDetail (item) {
      const name = resolveApprovalRouteName(item.processDefinitionKey)
      if (!name) return
      this.$router.push({
        name,
        query: buildApprovalDetailQuery(item),
      })
    },
    startConfirm (date) {
      this.params.applyStartDate = dayjs(date).format('YYYY-MM-DD')
      this.showStart = false
      this.onSearch()
    },
    clearApplyStartDate () {
      this.params.applyStartDate = ''
      this.startDate = null
      this.onSearch()
    },
  },
}



// WEBPACK FOOTER //
// ./src/page/srm/pendingApproval/ApprovalTab.vue